var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    "class": [{
      'required-field-placeholder-hint': _vm.required && !_vm.inputValue
    }, _vm.inputStyle === 'tailwind' ? 'input-style-tailwind' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-menu', {
    attrs: {
      "open-on-click": false,
      "close-on-content-click": false,
      "disable-keys": "",
      "offset-y": "",
      "max-height": "300",
      "min-width": "0",
      "max-width": "calc(100vw - 24px)",
      "content-class": "company-suggestions-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('div', _vm._b({}, 'div', attrs, false), [_vm.inputStyle === 'tailwind' ? [_c('div', {
          staticClass: "space-y-1.5"
        }, [_vm.label ? _c('label', {
          staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider"
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
          staticClass: "relative"
        }, [_c('input', {
          ref: "textField",
          "class": [_vm.twInputClass, _vm.errorMessages && _vm.errorMessages.length ? 'border-red-500' : ''],
          attrs: {
            "type": "text",
            "disabled": _vm.disabled,
            "placeholder": _vm.displayPlaceholder,
            "autofocus": _vm.autofocus
          },
          domProps: {
            "value": _vm.inputValue
          },
          on: {
            "input": function input($event) {
              return _vm.handleInput($event.target.value);
            },
            "focus": _vm.onFocus,
            "blur": _vm.onBlur,
            "keydown": _vm.onKeydown
          }
        }), _vm.loading ? _c('v-progress-circular', {
          staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2",
          attrs: {
            "indeterminate": "",
            "size": "20",
            "width": "2"
          }
        }) : _vm._e()], 1), _vm.errorMessages && _vm.errorMessages.length ? _c('p', {
          staticClass: "text-xs text-red-600"
        }, [_vm._v(_vm._s(_vm.errorMessages[0]))]) : _vm._e()])] : _c('v-text-field', {
          ref: "textField",
          attrs: {
            "disabled": _vm.disabled,
            "error-messages": _vm.errorMessages,
            "label": _vm.label,
            "placeholder": _vm.displayPlaceholder,
            "persistent-placeholder": _vm.required,
            "dense": _vm.dense,
            "outlined": _vm.outlined,
            "clearable": _vm.clearable,
            "loading": _vm.loading,
            "hide-details": "auto",
            "autofocus": _vm.autofocus
          },
          on: {
            "input": _vm.handleInput,
            "focus": _vm.onFocus,
            "blur": _vm.onBlur,
            "keydown": _vm.onKeydown
          },
          model: {
            value: _vm.inputValue,
            callback: function callback($$v) {
              _vm.inputValue = $$v;
            },
            expression: "inputValue"
          }
        })], 2)];
      }
    }]),
    model: {
      value: _vm.showSuggestions,
      callback: function callback($$v) {
        _vm.showSuggestions = $$v;
      },
      expression: "showSuggestions"
    }
  }, [_vm.suggestions.length ? _c('v-list', {
    staticClass: "suggestions-dropdown",
    attrs: {
      "dense": ""
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l(_vm.suggestions, function (suggestion, index) {
    return _c('v-list-item', {
      key: suggestion.siren || suggestion.name || index,
      "class": {
        'v-list-item--active': index === _vm.selectedIndex
      },
      staticStyle: {
        "cursor": "pointer",
        "padding": "12px 16px"
      },
      on: {
        "click": function click($event) {
          return _vm.selectSuggestion(suggestion);
        },
        "mouseenter": function mouseenter($event) {
          _vm.selectedIndex = index;
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticStyle: {
        "font-weight": "500",
        "margin-bottom": "4px"
      }
    }, [_vm._v(" " + _vm._s(suggestion.name) + " ")]), _c('v-list-item-subtitle', {
      staticStyle: {
        "font-size": "0.8rem",
        "color": "#666",
        "line-height": "1.4"
      }
    }, [suggestion.siren ? _c('div', {
      staticStyle: {
        "margin-bottom": "2px"
      }
    }, [_c('strong', [_vm._v("SIREN:")]), _vm._v(" " + _vm._s(suggestion.siren) + " ")]) : _vm._e(), suggestion.line1 || suggestion.line2 || suggestion.city || suggestion.postal_code || suggestion.country ? _c('div', {
      staticStyle: {
        "margin-bottom": "2px"
      }
    }, [_c('strong', [_vm._v("Adresse:")]), suggestion.line1 ? _c('span', [_vm._v(_vm._s(suggestion.line1))]) : _vm._e(), suggestion.line2 ? _c('span', [_vm._v(", " + _vm._s(suggestion.line2))]) : _vm._e(), (suggestion.line1 || suggestion.line2) && (suggestion.city || suggestion.postal_code) ? _c('span', [_vm._v(", ")]) : _vm._e(), suggestion.city ? _c('span', [_vm._v(_vm._s(suggestion.city))]) : _vm._e(), suggestion.postal_code ? _c('span', [_vm._v(" " + _vm._s(suggestion.postal_code))]) : _vm._e(), suggestion.country && (suggestion.city || suggestion.postal_code) ? _c('span', [_vm._v(", ")]) : _vm._e(), suggestion.country ? _c('span', [_vm._v(_vm._s(suggestion.country))]) : _vm._e()]) : _vm._e(), suggestion.vat_number ? _c('div', {
      staticStyle: {
        "margin-bottom": "2px"
      }
    }, [_c('strong', [_vm._v("TVA:")]), _vm._v(" " + _vm._s(suggestion.vat_number) + " ")]) : _vm._e()])], 1)], 1);
  }), 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "max-width": "600",
      "persistent": "",
      "content-class": "premium-gate-dialog"
    },
    model: {
      value: _vm.showPremiumGateDialog,
      callback: function callback($$v) {
        _vm.showPremiumGateDialog = $$v;
      },
      expression: "showPremiumGateDialog"
    }
  }, [_c('v-card', [_c('PremiumFeatureGateCompanyCompletion', {
    attrs: {
      "inline": false
    },
    on: {
      "input": function input($event) {
        _vm.showPremiumGateDialog = $event;
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }